// Runs fn just after the browser has painted, when the page is already laid out
// and reading a size or scroll position costs nothing. Reading one right after
// React commits makes the browser lay out the whole page on the spot, which
// PageSpeed reports as a forced reflow. Returns a function that cancels it.
export default function afterPaint(fn) {
  let timer = 0;
  const frame = window.requestAnimationFrame(() => {
    timer = window.setTimeout(fn, 0);
  });
  return () => {
    window.cancelAnimationFrame(frame);
    window.clearTimeout(timer);
  };
}
